import React from 'react'
import { feedbotToast } from '../toastDispatchers'

export const toastNotifyInvalidClipboardError = () => {
  const title = 'Invalid clipboard content'

  const content = (
    <>
      There is an invalid clipboard content - you simply copied something we are not able to paste.
      Try it again using “Copy step” or “Copy dialog” functions in the context menu that every step
      has or contact{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://feedyou.atlassian.net/servicedesk/customer/portals"
      >
        our support
      </a>
      .
    </>
  )

  feedbotToast.error({ title, content })
}
